export const getRecordedContentFileName = (url) =>
  url
    ?.substring(url.lastIndexOf("/") + 1) // raw file name
    .split("%20") // remove space entities
    .join(" "); // build name
